var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper",style:(_vm.activeRequestsCount > 0 ? 'overflow: hidden' : ''),attrs:{"lang":_vm.lang}},[_c('Header'),_c('div',{staticClass:"main-content"},[_c('router-view'),_c('Preloader')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }